'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Dictionary = require('./classes/Dictionary');

var _Dictionary2 = _interopRequireDefault(_Dictionary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _Dictionary2.default({
  DOCUSIGN_EMAIL: 'odiso.codevigor@gmail.com',
  DOCUSIGN_PASSWORD: 'codevigor',
  DOCUSIGN_ACCOUNT_ID: '9abe27c3-0493-45c8-9d91-b692606d3b9a',
  DOCUSIGN_API_URL: 'https://demo.docusign.net/restapi/v2.1',
  DOCUSIGN_INTEGRATION_KEY: '9c0bd04a-b17c-485a-a332-3b2e27b5017f',
  DOCUSIGN_SECRET_KEY: '893cd784-0b04-471c-8c30-e5b22a6c02df'
});